import Floorplate from "./Floorplate";

export * from "./Floorplate";

export default Floorplate;
